import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import validator from "validator";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";
import helperTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";
import Pagination from "../../partials/content/Pagination";

export default function AllTransactionScoreToWalletAdvertiser() {
  const [
    allTransactionScoreToWalletAdvertiser,
    setAllTransactionScoreToWalletAdvertiser,
  ] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getAllTransactionScoreToWalletAdvertiser();
  }, []);

  useEffect(() => {
    getAllTransactionScoreToWalletAdvertiser();
  }, [currentPage, countItemPerPage]);

  const getAllTransactionScoreToWalletAdvertiser = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allTransactionScoreToWalletAdvertiser =
      await sendRequestGetAllTransactionScoreToWalletAdvertiser();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!allTransactionScoreToWalletAdvertiser) {
      return;
    }
    setAllTransactionScoreToWalletAdvertiser(
      allTransactionScoreToWalletAdvertiser.transaction_score
    );
    setCountPage(allTransactionScoreToWalletAdvertiser.count_page);
  };

  const generateUserDoseNotHaveTransactionScoreToWalletAdvertiser = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img src="/assets/img/do-not-have-position.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p>شما هیج درخواست تبدیل Hicoin به شارژ تبلیغ دهنده ندارید.</p>

          <p>
            <Link
              to="/finance/add-transaction-score-to-wallet-advertiser"
              className="btn btn-success"
            >
              <span className="pl-2">
                <i className="fa fa-plus"> </i>
              </span>
              <span>درخواست تبدیل Hicoin به شارژ تبلیغ دهنده</span>
            </Link>
          </p>
        </div>
      </div>
    );
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllTransactionScoreToWalletAdvertiser = async () => {
    const headersRequest = getHeaderRequest();
    let allTransactionScoreToWalletAdvertiser;
    try {
      allTransactionScoreToWalletAdvertiser = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/publisher/transaction-score-to-wallet-advertiser?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allTransactionScoreToWalletAdvertiser.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAllTransactionScoreToWalletAdvertiser = () => {
    return (
      <>
        <div className="pb-4 px-2">
          <div>
            <Link
              to="/finance/add-transaction-score-to-wallet-advertiser"
              className="btn btn-success"
            >
              <span className="pl-2">
                <i className="fa fa-plus"> </i>
              </span>
              <span>درخواست تبدیل Hicoin به شارژ تبلیغ دهنده</span>
            </Link>
          </div>
          <div className="table-responsive pt-2">
            <table className="table table-hilite tbl-td-white-space">
              <thead>
                <tr>
                  <td>#</td>
                  <td>شماره تبدیل</td>
                  <td>Hicoin</td>
                  <td>شارژ تبلیغ دهنده (تومان)</td>
                  <td>تاربخ درج</td>
                </tr>
              </thead>
              <tbody>
                {allTransactionScoreToWalletAdvertiser.map((item, index) => {
                  return (
                    <tr>
                      <td>{helperNumbers.toPersianNum(index + 1)}</td>
                      <td>{helperNumbers.toPersianNum(item.id)}</td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(
                            item.score_publisher
                          )
                        )}
                      </td>
                      <td className="letter-spacing-finance-number">
                        {helperNumbers.toPersianNum(
                          helperNumbers.toFormatFinanceNumber(
                            item.wallet_advertiser
                          )
                        )}
                      </td>

                      <td>
                        {helperNumbers.toPersianNum(
                          item.created_at.split(" ")[1] +
                            " " +
                            helperTime.convertGregorianToJalali(
                              item.created_at.split(" ")[0]
                            )
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {countPage > 1 ? generatePagination() : <></>}
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar
        openItem="finance"
        activeItem="all-transaction-score-to-wallet-advertiser"
      />

      <div className="content-wrapper">
        <TitleBar
          title="تبدیل Hicoin به شارژ تبلیغ دهنده
"
        />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {allTransactionScoreToWalletAdvertiser.length > 0
                ? generateAllTransactionScoreToWalletAdvertiser()
                : generateUserDoseNotHaveTransactionScoreToWalletAdvertiser()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
